'use client';

import { useState } from 'react';
import Image from 'next/image';
import { TextButton } from '@components/button';
import arrow from '@images/ico_footer_arrow.svg';
import { TranslatedNavItem } from '@/hooks/useMenu.hook';
import { TrackedAnchor } from '../ancher';

const linkStyles =
  'mb-[20px] border-none font-bold leading-none hover:text-[#ff142d] focus:text-[#ff142d]';

const LinkItem = ({ item }: { item: TranslatedNavItem }) => (
  <li className="main-hero:max-xl:w-full lg:w-[140px]">
    <TextButton size="large" className={linkStyles} asChild>
      <TrackedAnchor
        href={item.href}
        position="footer"
        label={item.gtagLabel}
        prefetch={false}
      >
        {item.label}
      </TrackedAnchor>
    </TextButton>
  </li>
);

const NestedLinkedItem = ({ item }: { item: TranslatedNavItem }) => {
  const [isOpen, setIsOpen] = useState(false);
  const subItems = item.groups?.flatMap(group => group.items) ?? [];

  return (
    <li>
      <div
        className="flex w-full cursor-pointer items-center justify-between main-hero:max-xl:w-full main-hero:max-xl:cursor-pointer lg:w-[140px] lg:cursor-auto"
        onClick={() => setIsOpen(state => !state)}
      >
        <TextButton size="large" className={linkStyles} asChild>
          <TrackedAnchor
            href={item.href}
            position="footer"
            label={item.gtagLabel}
            prefetch={false}
          >
            {item.label}
          </TrackedAnchor>
        </TextButton>
        <div className="mb-[12px] main-hero:max-xl:block lg:hidden">
          <Image
            src={arrow}
            width={13}
            height={8}
            alt="arrow"
            className={isOpen ? 'rotate-180' : ''}
          />
        </div>
      </div>
      <ul
        className={`mb-[10px] ${isOpen ? 'block' : 'hidden main-hero:max-xl:hidden'} lg:block`}
      >
        {subItems.map(sub => (
          <li key={sub.href} className="mb-[5px]">
            <TextButton
              size="large"
              className="my-0 border-none font-medium text-[rgba(4,2,53,70%)] hover:text-[#040435]"
              asChild
            >
              <TrackedAnchor
                href={sub.href}
                position="footer"
                label={sub.gtagLabel}
                prefetch={false}
                target={sub.target}
                rel={sub.rel}
              >
                {sub.label}
              </TrackedAnchor>
            </TextButton>
          </li>
        ))}
      </ul>
    </li>
  );
};

export { LinkItem, NestedLinkedItem };
